<template>
  <div>
    <h2 class="ui header text-center">
      红豆云会员权益
    </h2>
    <hr>
    <table class="ui teal unstackable table">
      <thead>
        <tr>
          <th></th>
          <th>
            基础版
          </th>
          <th>
            标准版
            <span class="ui yellow label recommended">推荐</span>
          </th>
          <th>
            专业版
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="font-bold">
            空间容量
            <span data-variation="basic fixed" data-position="bottom left" data-tooltip="“我的网盘”的存储空间大小">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>1G</td>
          <td>10G</td>
          <td>50G</td>
        </tr>
        <tr>
          <td class="font-bold">
            历史版本空间
            <span data-variation="basic fixed" data-position="bottom left" data-tooltip="您的每一步操作记录都会保存在您的历史版本空间内，包括删除记录、上传记录、重命名记录、移动记录、复制记录、新建文件夹记录、文件闪传转存记录等，您可以在历史版本记录内找到您操作过的每一个时间节点的网盘的状态，也可以从这些状态中选择恢复删除的文件，以及下载其中任意的文件。当历史版本空间占满以后，会删除最老的历史版本记录，以便保存新的历史版本记录。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>1G</td>
          <td>20G</td>
          <td>200G</td>
        </tr>
        <tr>
          <td class="font-bold">
            文件闪传
            <span data-variation="basic fixed" data-position="bottom left" data-tooltip="无需登录账号，扫描二维码(或者访问对应的链接)快速给自己传文件/文件夹/文本消息。可以方便的从手机端或是其他人的电脑网页端给自己传输数据，然后转存至“我的网盘”。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>20M</td>
          <td>1G</td>
          <td>10G</td>
        </tr>
        <tr>
          <td class="font-bold">
            上传流量
            <span data-variation="basic fixed" data-position="bottom left" data-tooltip="向“我的网盘”上传数据的总量，从您购买资源套餐的时刻算起，每过一个月自动清零。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>1G</td>
          <td>无限制</td>
          <td>无限制</td>
        </tr>
        <tr>
          <td class="font-bold">
            下载流量
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="从“我的网盘”下载数据的总量，从您购买资源套餐的时刻算起，每过一个月自动清零。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>1G</td>
          <td>10G</td>
          <td>50G</td>
        </tr>
        <tr>
          <td class="font-bold">
            多云备份
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="您保存在红豆云的数据会根据您购买的资源套餐版本的不同，保存在单个或多个云端，如阿里云、华为云、AWS等，多云备份降低了由于某一个云服务器崩溃等原因导致的数据丢失的可能性。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>无</td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">
            极速上传
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="我们的目标是您的网速有多快，您的上传速度就有多快！">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">
            极速下载
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="我们的目标是您的网速有多快，您的下载速度就有多快！">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">
            搜索
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="您可以在“我的网盘”、“密码管理器”和“历史版本记录”中各自搜索关键词进行匹配。 批量上传数量：您一次性选中多个文件进行上传的数量限制。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">
            批量上传数量
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="您一次性选中多个文件进行上传的数量限制。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>无限制</td>
          <td>无限制</td>
          <td>无限制</td>
        </tr>
        <tr>
          <td class="font-bold">
            密码管理器
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="您可以将您在不同网站的账号和密码记录在这里，并使用“项目名称”、“标签”、“收藏”等功能对其进行管理，也可以用搜索快速方便的找到对应网站的账号和密码，有效防止一个密码泄露导致的其他账户也被盗取的损失。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td>100条</td>
          <td>无限制</td>
          <td>无限制</td>
        </tr>
        <tr>
          <td class="font-bold">
            速记本
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="将一些临时的重要笔记安全的记录在这里，随记随保存。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">
            文件预览
            <span data-variation="basic fixed" data-position="bottom left"
              data-tooltip="出于安全性的考虑，目前支持照片和txt的预览，后续可能会支持更多类型的文件。">
              <i class="question circle outline icon text-gray-600"></i>
            </span>
          </td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr>
          <td class="font-bold">大文件上传</td>
          <td>200MB</td>
          <td>无限制</td>
          <td>无限制</td>
        </tr>
        <tr>
          <td class="font-bold">误删文件恢复</td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
          <td><i class="ui teal large check icon"></i></td>
        </tr>
        <tr class="text-xl font-bold prices">
          <td class="font-bold">价格</td>
          <td>9.9元/月</td>
          <td>27.9元/月</td>
          <td>89.9元/月</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PricingTable',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
tr.prices td {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
span.recommended {
  margin-left: 1rem !important;
}
</style>

